module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 11-11-08-163.7a4d8cbe.mp4";